import React from 'react';

export default function TemplateDokumen() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Template Dokumen</h1>
      <p className="text-gray-500">Halaman Template Dokumen</p>
    </div>
  );
}
